import { ValueProvider } from '@angular/core';
import {
  API_ENDPOINT_DOC_PATH,
  BdAppConfigRequest,
  BdAppConfigResponse,
  resolveDiagnosticsEndpoints,
} from '@bindoc-projects/app-config-domain-lib';
import { DIAGNOSTICS_CONFIG } from './diagnostics.config';
import { EXTERNAL_DIAGNOSTICS_ENDPOINTS } from './external-endpoints';

export function provideDiagnosticsConfig(
  appConfigRequest: BdAppConfigRequest,
  appConfigResponse: BdAppConfigResponse,
): ValueProvider {
  const allKeys = [
    ...appConfigRequest.apiEndpointKeys,
    ...(appConfigRequest.unprotectedApiEndpointKeys ?? []),
  ];

  const endpoints = resolveDiagnosticsEndpoints(
    allKeys,
    appConfigResponse.apiEndpoints,
    API_ENDPOINT_DOC_PATH,
    appConfigResponse.backendHosts,
  );

  return {
    provide: DIAGNOSTICS_CONFIG,
    useValue: {
      appId: appConfigRequest.id,
      environment: appConfigResponse.environment,
      endpoints: [...endpoints, ...EXTERNAL_DIAGNOSTICS_ENDPOINTS],
    },
  };
}
